import {
  IconX, IconSwords, IconStopwatch, IconVersus, IconTeam, IconDirectorChair, IconTrophy,
} from '../icons'

const MODES = [
  { id: 'battle-royale', Icon: IconSwords,        name: 'Battle Royale',  desc: 'Every player for themselves' },
  { id: 'speed-run',     Icon: IconStopwatch,     name: 'Speed Run',      desc: 'Fastest time wins' },
  { id: 'h2h',           Icon: IconVersus,        name: 'H2H',            desc: 'Team vs team showdown' },
  { id: 'co-op',         Icon: IconTeam,          name: 'Co-Op',          desc: 'Work together as one' },
  { id: 'directors-cut', Icon: IconDirectorChair, name: "Director's Cut", desc: 'Vote on each connection' },
  { id: 'trilogy',       Icon: IconTrophy,        name: 'The Trilogy',    desc: 'Three rounds. One champion.' },
]

/**
 * Party Mode is conceptually a host/big-screen popup window — its only action
 * is to dismiss back to whatever launched it. `onClose` is the dismiss handler
 * (in the current SPA: route back to the Multiplayer menu; in a future
 * window.open() world: window.close()).
 *
 * The earlier "Multiplayer · Home" BottomNav from the kill-back-buttons PR is
 * replaced here on purpose — Party Mode's framing is a popup, not a screen.
 */
export default function PartyModeSelect({ onSelectMode, onClose }) {
  return (
    <div className="party-mode-select">
      <div className="screen-content">
        <h2 className="party-mode-select__title">Party Mode</h2>
        <p className="party-mode-select__sub">Choose your game format</p>

        <div className="party-mode-grid">
          {MODES.map((mode) => (
            <button
              key={mode.id}
              className="party-mode-card"
              onClick={() => onSelectMode(mode.id)}
            >
              <span className="party-mode-card__icon">
                <mode.Icon size={26} />
              </span>
              <span className="party-mode-card__name">{mode.name}</span>
              <span className="party-mode-card__desc">{mode.desc}</span>
            </button>
          ))}
        </div>

        <p className="party-mode-select__ticket-note">1 ticket per player</p>

        <div className="party-mode-close-row">
          <button
            type="button"
            className="party-close-btn"
            onClick={onClose}
            aria-label="Close"
            title="Close"
          >
            <IconX size={22} />
          </button>
          <span className="party-close-label">Close</span>
        </div>
      </div>
    </div>
  )
}
